import ErrorFallBack from '@atoms/ErrorFallBack';

import config from '@config';
import AppWithDownTime from '@navigation/AppWithDowntime.web';
import navigationConstants from '@navigation/navigationConstants';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AmplitudeHelper from '@utils/analytics';
import initializePerformanceTool from '@utils/performance';
import sessionManager from '@utils/sessionManager';
import * as Linking from 'expo-linking';
import React, { useEffect, useState } from 'react';
import { Alert, Platform } from 'react-native';
import ReactPWAInstallProvider from 'react-pwa-install';
import * as Sentry from 'sentry-expo';
import * as serviceWorkerRegistration from './web/serviceWorkerRegistration';

const prefix = Linking.createURL('/');
AmplitudeHelper.init();
initializePerformanceTool();

function GGApp() {
  const [isDeepLinkRedirect, setIsDeepLinkRedirect] = useState(false);
  useEffect(() => {
    if (Platform.OS === 'web') {
      const url = window.location.href;

      // Adjust this logic to match your fallback route path
      if (url.includes('/go')) {
        setIsDeepLinkRedirect(true);
      }
    }
  }, []);
  const linking = {
    prefixes: [prefix],
    config: {
      screens: {
        [navigationConstants.HOME]: 'home',
        [navigationConstants.PembayaranTab]: 'billPayment',
        [navigationConstants.TransactionsTab]: 'Transactions',
        [navigationConstants.ProfileTab]: 'profile',
        DeepLinkRedirect: {
          path: 'go',
          parse: {
            link: link => decodeURIComponent(link),
          },
        },
      },
    },
  };

  useEffect(() => {
    sessionManager.init();
  }, []);

  return Sentry.Browser.wrap(() => (
    <>
      {config.ENVIRONMENT === 'staging' ? <ReactQueryDevtools initialIsOpen={false} /> : null}
      <ErrorFallBack>
        <ReactPWAInstallProvider enableLogging>
          <AppWithDownTime linking={linking} isDeepLinkRedirect={isDeepLinkRedirect} />
        </ReactPWAInstallProvider>
      </ErrorFallBack>
    </>
  ));
}

serviceWorkerRegistration.register({
  onSuccess: () => {},
  onUpdate: reg => {
    Alert.alert(
      'Update available',
      'Gaji-Gesa updated in the back-end',
      [
        {
          text: 'Update',
          onPress: () => {},
        },
        { text: 'Cancel' },
      ],
      {
        cancelable: true,
        onDismiss: () => {},
      },
    );
  },
});

export default GGApp;
